import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { axiosInstance } from "../../utils/axios";
import { Link, useParams } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import Break from "./Break";
import Session from "./Session";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import {
  Box,
  Button,
  Divider as MuiDivider,
  Grid,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";
import TrackTab from "./Track";

const Divider = styled(MuiDivider)(spacing);

function Sessions() {
  const { id: eventId } = useParams();
  console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@ 666666", eventId);
  console.log("Current eventId:", eventId);

  const [tracks, setTracks] = useState([]);
  const [sessionsByDate, setSessionsByDate] = useState({});
  const [breaks, setBreaks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [state, setState] = useState({
    right: false,
  });
  const [editingSession, setEditingSession] = useState(null);
  const [editDrawerOpen, setEditDrawerOpen] = useState(false);
  const [editingBreak, setEditingBreak] = useState(null);
  const [editBreakDrawerOpen, setEditBreakDrawerOpen] = useState(false);

  const refreshData = async () => {
    try {
      console.log(
        "🔄 RefreshData - Starting to fetch data for eventId:",
        eventId
      );

      const breaksResponse = await axiosInstance.post("/graphql", {
        query: BREAKS_QUERY,
        variables: {
          eventId: eventId,
        },
      });

      console.log("🔄 RefreshData - Breaks response:", breaksResponse);
      console.log("🔄 RefreshData - Breaks data:", breaksResponse.data);

      if (breaksResponse.data.errors) {
        console.error(
          "❌ RefreshData - Breaks query errors:",
          breaksResponse.data.errors
        );
      }

      const breaksData = breaksResponse.data?.getBreaks || [];
      console.log("🔄 RefreshData - Setting breaks:", breaksData);
      setBreaks(breaksData);

      const sessionsResponse = await axiosInstance.post("/graphql", {
        query: SESSIONS_QUERY,
        variables: {
          eventId: eventId,
        },
      });

      console.log("🔄 RefreshData - Sessions response:", sessionsResponse);
      console.log("🔄 RefreshData - Sessions data:", sessionsResponse.data);

      if (sessionsResponse.data.errors) {
        console.error(
          "❌ RefreshData - Sessions query errors:",
          sessionsResponse.data.errors
        );
      }

      const sessionsData = sessionsResponse.data?.getSessions || [];
      console.log("🔄 RefreshData - Sessions array:", sessionsData);

      const groupedSessions = sessionsData.reduce((acc, session) => {
        // Handle both timestamp and ISO string formats
        let date;
        console.log(
          "RefreshData - Processing session date:",
          session.sessionDate,
          typeof session.sessionDate
        );

        if (typeof session.sessionDate === "string") {
          // Check if it's a string containing a timestamp (all digits)
          if (/^\d+$/.test(session.sessionDate)) {
            const timestamp = parseInt(session.sessionDate, 10);
            console.log("RefreshData - String timestamp parsed to:", timestamp);
            date = new Date(timestamp);
          } else {
            // It's an ISO string
            date = new Date(session.sessionDate);
          }
        } else if (typeof session.sessionDate === "number") {
          date = new Date(session.sessionDate);
        } else {
          // Fallback: try parsing as integer
          const timestamp = parseInt(session.sessionDate, 10);
          console.log("RefreshData - Fallback parsed timestamp:", timestamp);
          date = new Date(timestamp);
        }

        console.log(
          "RefreshData - Created date object:",
          date,
          "Valid:",
          !isNaN(date.getTime())
        );

        if (isNaN(date.getTime())) {
          console.error(
            "RefreshData - Invalid date:",
            session.sessionDate,
            "Parsed as:",
            date
          );
          return acc;
        }
        const formattedDate = date.toISOString().split("T")[0];
        if (!acc[formattedDate]) acc[formattedDate] = [];
        acc[formattedDate].push(session);
        return acc;
      }, {});

      setSessionsByDate(groupedSessions);
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const TRACKS_QUERY = `
    query Tracks($eventId: ID) {
      tracks(eventId: $eventId) {
        id
        name
        description
      }
    }
  `;

  const SESSIONS_QUERY = `
    query GetSessions($eventId: ID) {
      getSessions(eventId: $eventId) {
        id
        name
        sessionDate
        sessionTime
        duration
        description
        hosts {
          id
          firstName
          lastName
          email
          jobTitle
          organization
          category
        }
        coHosts {
          id
          firstName
          lastName
          email
          jobTitle
          organization
          category
        }
        speakers {
          id
          firstName
          lastName
          email
          jobTitle
          organization
          category
        }
        tracks {
          id
          name
          description
        }
        tags
      }
    }
  `;

  const BREAKS_QUERY = `
    query GetBreaks($eventId: ID) {
      getBreaks(eventId: $eventId) {
        id
        name
        breakDate
        breakTime
        duration
        description
        tracks {
          id
          name
          description
        }
      }
    }
  `;

  useEffect(() => {
    console.log("useEffect triggered with eventId:", eventId);

    const fetchData = async () => {
      console.log("Starting to fetch data...");
      try {
        const tracksResponse = await axiosInstance.post("/graphql", {
          query: TRACKS_QUERY,
          variables: {
            eventId: eventId,
          },
        });
        console.log("Tracks response:", tracksResponse);

        const sessionsResponse = await axiosInstance.post("/graphql", {
          query: SESSIONS_QUERY,
          variables: {
            eventId: eventId,
          },
        });
        console.log("Sessions response:", sessionsResponse);
        console.log("Sessions data:", sessionsResponse.data);

        if (sessionsResponse.data.errors) {
          console.error(
            "❌ FetchData - Sessions query errors:",
            sessionsResponse.data.errors
          );
        }

        const breaksResponse = await axiosInstance.post("/graphql", {
          query: BREAKS_QUERY,
          variables: {
            eventId: eventId,
          },
        });
        console.log("Breaks response:", breaksResponse);
        console.log("Breaks data:", breaksResponse.data);

        if (breaksResponse.data.errors) {
          console.error(
            "❌ FetchData - Breaks query errors:",
            breaksResponse.data.errors
          );
        }

        setTracks(tracksResponse.data.tracks);

        const sessionsData = sessionsResponse.data?.getSessions || [];
        console.log("FetchData - Sessions array:", sessionsData);

        const groupedSessions = sessionsData.reduce((acc, session) => {
          // Handle both timestamp and ISO string formats
          let date;
          console.log(
            "Processing session date:",
            session.sessionDate,
            typeof session.sessionDate
          );

          if (typeof session.sessionDate === "string") {
            // Check if it's a string containing a timestamp (all digits)
            if (/^\d+$/.test(session.sessionDate)) {
              const timestamp = parseInt(session.sessionDate, 10);
              console.log("String timestamp parsed to:", timestamp);
              date = new Date(timestamp);
            } else {
              // It's an ISO string
              date = new Date(session.sessionDate);
            }
          } else if (typeof session.sessionDate === "number") {
            date = new Date(session.sessionDate);
          } else {
            // Fallback: try parsing as integer
            const timestamp = parseInt(session.sessionDate, 10);
            console.log("Fallback parsed timestamp:", timestamp);
            date = new Date(timestamp);
          }

          console.log(
            "Created date object:",
            date,
            "Valid:",
            !isNaN(date.getTime())
          );

          if (isNaN(date.getTime())) {
            console.error(
              "Invalid date:",
              session.sessionDate,
              "Parsed as:",
              date
            );
            return acc;
          }
          const formattedDate = date.toISOString().split("T")[0];
          if (!acc[formattedDate]) acc[formattedDate] = [];
          acc[formattedDate].push(session);
          return acc;
        }, {});

        setSessionsByDate(groupedSessions);

        const breaksData = breaksResponse.data?.getBreaks || [];
        console.log("FetchData - Breaks array:", breaksData);
        setBreaks(breaksData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    if (eventId) {
      console.log("Calling fetchData with eventId:", eventId);
      fetchData();
    } else {
      console.log("No eventId available");
      setLoading(false);
    }
  }, [eventId]);

  const handleEditSession = (session) => {
    setEditingSession(session);
    setEditDrawerOpen(true);
  };

  const handleDeleteSession = async (sessionId) => {
    if (!window.confirm("Are you sure you want to delete this session?")) {
      return;
    }

    try {
      const response = await axiosInstance.post("/graphql", {
        query: `
          mutation DeleteSession($id: ID!, $eventId: ID!) {
            deleteSession(id: $id, eventId: $eventId)
          }
        `,
        variables: {
          id: sessionId,
          eventId: eventId,
        },
      });

      if (response.errors) {
        throw new Error(
          response.errors[0]?.message || "Failed to delete session"
        );
      }

      setSuccessMessage("Session deleted successfully!");
      await refreshData(); // Refresh the session list
    } catch (error) {
      console.error("Error deleting session:", error);
      setSuccessMessage("Error deleting session: " + error.message);
    }
  };

  const handleEditBreak = (breakItem) => {
    console.log("🔧 Editing break:", breakItem);
    console.log("🔧 Break data structure:");
    console.log("  - id:", breakItem.id);
    console.log("  - name:", breakItem.name);
    console.log(
      "  - breakDate:",
      breakItem.breakDate,
      typeof breakItem.breakDate
    );
    console.log(
      "  - breakTime:",
      breakItem.breakTime,
      typeof breakItem.breakTime
    );
    console.log("  - duration:", breakItem.duration, typeof breakItem.duration);
    console.log("  - description:", breakItem.description);
    setEditingBreak(breakItem);
    setEditBreakDrawerOpen(true);
  };

  const handleDeleteBreak = async (breakId) => {
    if (!window.confirm("Are you sure you want to delete this break?")) {
      return;
    }

    try {
      console.log("🗑️ Deleting break with ID:", breakId);

      const response = await axiosInstance.post("/graphql", {
        query: `
          mutation DeleteBreak($id: ID!, $eventId: ID!) {
            deleteBreak(id: $id, eventId: $eventId)
          }
        `,
        variables: {
          id: breakId,
          eventId: eventId,
        },
      });

      console.log("🗑️ Delete break response:", response);

      // Check for errors in multiple possible response structures
      if (response.errors) {
        throw new Error(
          response.errors[0]?.message || "Failed to delete break"
        );
      }

      if (response.data?.errors) {
        throw new Error(
          response.data.errors[0]?.message || "Failed to delete break"
        );
      }

      // Check if the deletion was successful
      const deleteResult = response.data?.deleteBreak ?? response.deleteBreak;
      console.log("🗑️ Delete result:", deleteResult);

      if (deleteResult !== true) {
        throw new Error(
          "Failed to delete break - operation did not return true"
        );
      }

      setSuccessMessage("Break deleted successfully!");
      await refreshData(); // Refresh the breaks list
    } catch (error) {
      console.error("❌ Error deleting break:", error);
      setSuccessMessage("Error deleting break: " + error.message);
    }
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      style={{ width: "400px" }}
    >
      <TrackTab eventId={eventId} onClose={toggleDrawer("right", false)} />
    </Box>
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <Snackbar
        open={!!successMessage}
        autoHideDuration={4000}
        onClose={() => setSuccessMessage("")}
      >
        <Alert severity="success" onClose={() => setSuccessMessage("")}>
          {successMessage}
        </Alert>
      </Snackbar>

      <Grid container spacing={10} justifyContent="space-between">
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Sessions
          </Typography>
          <Typography component="div">
            Choose from the different types of sessions to add to your event
            schedule
          </Typography>
        </Grid>
        <Grid item>
          <div>
            <Link
              variant="contained"
              color="primary"
              onClick={toggleDrawer("right", true)}
              style={{
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "0.9rem",
                marginRight: "1rem",
              }}
            >
              Add Tracks
            </Link>
            <Drawer
              anchor={"right"}
              open={state["right"]}
              onClose={toggleDrawer("right", false)}
            >
              {list("right")}
            </Drawer>
            <Break eventId={eventId} onBreakAdded={refreshData} />{" "}
            {/* Pass eventId here */}
            <Session eventId={eventId} onSessionAdded={refreshData} />{" "}
            {/* Pass eventId here */}
          </div>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={10} justifyContent="space-between">
        <Grid item md={12}>
          <Grid item md={8}>
            <span style={{ marginRight: "10px" }}> Tracks </span>
            {tracks.map((track) => (
              <Button
                key={track.id}
                variant="outlined"
                sx={{ mr: 2, display: { xs: "none", md: "inline" } }}
                style={{ borderRadius: "30px" }}
              >
                {track.name}
              </Button>
            ))}
          </Grid>

          <Grid item md={12} style={{ marginTop: "20px" }}>
            {Object.keys(sessionsByDate).map((date) => (
              <Button
                key={date}
                variant="contained"
                sx={{ mr: 2, display: { xs: "none", md: "inline" } }}
              >
                {new Date(date).toDateString()}
              </Button>
            ))}
          </Grid>

          <Timeline
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.1,
              },
            }}
          >
            {Object.keys(sessionsByDate).map((date) =>
              sessionsByDate[date].map((session, index) => (
                <TimelineItem key={index}>
                  <TimelineOppositeContent color="textSecondary">
                    {new Date(
                      `1970-01-01T${session.sessionTime}Z`
                    ).toLocaleTimeString()}{" "}
                    {session.duration} Min
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    {session.name}
                    <EditIcon
                      onClick={() => handleEditSession(session)}
                      style={{
                        position: "relative",
                        top: "5px",
                        width: "1rem",
                        marginLeft: "10px",
                        cursor: "pointer",
                        color: "#1976d2",
                      }}
                    />
                    <DeleteIcon
                      onClick={() => handleDeleteSession(session.id)}
                      style={{
                        position: "relative",
                        top: "5px",
                        color: "red",
                        width: "1rem",
                        cursor: "pointer",
                      }}
                    />
                    <Typography component="div">
                      {session.description}
                    </Typography>
                    {session.tracks && session.tracks.length > 0 && (
                      <Typography
                        component="div"
                        variant="caption"
                        sx={{ mt: 1 }}
                      >
                        <strong>Tracks:</strong>{" "}
                        {session.tracks.map((track, idx) => (
                          <span key={track.id}>
                            {track.name}
                            {idx < session.tracks.length - 1 ? ", " : ""}
                          </span>
                        ))}
                      </Typography>
                    )}
                  </TimelineContent>
                </TimelineItem>
              ))
            )}

            {breaks.map((breakItem, index) => (
              <TimelineItem key={index}>
                <TimelineOppositeContent color="textSecondary">
                  {new Date(
                    `1970-01-01T${breakItem.breakTime}Z`
                  ).toLocaleTimeString()}{" "}
                  {breakItem.duration} Min
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                  {breakItem.name}
                  <EditIcon
                    onClick={() => handleEditBreak(breakItem)}
                    style={{
                      position: "relative",
                      top: "5px",
                      width: "1rem",
                      marginLeft: "10px",
                      cursor: "pointer",
                      color: "#1976d2",
                    }}
                  />
                  <DeleteIcon
                    onClick={() => handleDeleteBreak(breakItem.id)}
                    style={{
                      position: "relative",
                      top: "5px",
                      color: "red",
                      width: "1rem",
                      cursor: "pointer",
                    }}
                  />
                  <Typography component="div">
                    {breakItem.description}
                  </Typography>
                  {breakItem.tracks && breakItem.tracks.length > 0 && (
                    <Typography
                      component="div"
                      variant="caption"
                      sx={{ mt: 1 }}
                    >
                      <strong>Tracks:</strong>{" "}
                      {breakItem.tracks.map((track, idx) => (
                        <span key={track.id}>
                          {track.name}
                          {idx < breakItem.tracks.length - 1 ? ", " : ""}
                        </span>
                      ))}
                    </Typography>
                  )}
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </Grid>
      </Grid>

      {/* Edit Session Drawer */}
      <Drawer
        anchor="right"
        open={editDrawerOpen}
        onClose={() => {
          setEditDrawerOpen(false);
          setEditingSession(null);
        }}
      >
        <Box sx={{ width: "600px", padding: "20px" }}>
          {editingSession && (
            <Session
              eventId={eventId}
              onSessionAdded={() => {
                refreshData();
                setEditDrawerOpen(false);
                setEditingSession(null);
              }}
              editMode={true}
              sessionToEdit={editingSession}
              onClose={() => {
                setEditDrawerOpen(false);
                setEditingSession(null);
              }}
            />
          )}
        </Box>
      </Drawer>

      {/* Edit Break Drawer */}
      <Drawer
        anchor="right"
        open={editBreakDrawerOpen}
        onClose={() => {
          setEditBreakDrawerOpen(false);
          setEditingBreak(null);
        }}
      >
        <Box sx={{ width: "600px", padding: "20px" }}>
          {editingBreak && (
            <Break
              eventId={eventId}
              onBreakAdded={() => {
                refreshData();
                setEditBreakDrawerOpen(false);
                setEditingBreak(null);
              }}
              editMode={true}
              breakToEdit={editingBreak}
              onClose={() => {
                setEditBreakDrawerOpen(false);
                setEditingBreak(null);
              }}
            />
          )}
        </Box>
      </Drawer>
    </React.Fragment>
  );
}

export default Sessions;
